import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ITimeSheetVisibilityService } from './time-sheet-visibility.types';

@Injectable({
	providedIn: 'root'
})
export class TimeSheetVisibilityService implements ITimeSheetVisibilityService {
	private visibilityStatus: Subject<boolean> = new Subject<boolean>();

	public getTimeSheetMobileVisibility(): Observable<boolean> {
		return this.visibilityStatus.asObservable();
	}

	public setTimeSheetMobileVisibility(isVisible: boolean = false): void {
		this.visibilityStatus.next(isVisible);
	}
}
